module.exports = __webpack_public_path__ + "img/pk.fa062eb3.svg";